import { History } from "history";
import { combineReducers } from "redux";
import { StateType } from "typesafe-actions";
import { connectRouter } from "connected-react-router";
import { UserReducer } from "./reducers/users/users.reducers";
import { AuthorizationReducer } from "./reducers/authorization/authorization.reducers";import { BookingReducer } from "./reducers/bookings/reducers";
import { InventoryReducer } from "./reducers/inventories/inventories.reducers";
import { RoomReducer } from "./reducers/rooms/rooms.reducers";
import { RoleReducer } from "./reducers/roles/roles.reducers";
;

export const makeRootReducer = (history: History) => {
  return combineReducers({
    router: connectRouter(history),
    role: RoleReducer,
    user: UserReducer,
    room: RoomReducer,
    booking: BookingReducer,
    inventory: InventoryReducer,
    authorization: AuthorizationReducer,
  });
};

export type RootState = StateType<ReturnType<typeof makeRootReducer>>;
